export default __webpack_public_path__ + "static/media/invoice.efa345a6.svg";